import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router';
import { useAPI } from 'src/api/provider';
import { LoadingView } from 'src/lib/LoadingView';
import Container from './components/Container';

export const FacilityAppSSO = () => {
    const { t } = useTranslation('auth.login');
    const { t: errorT } = useTranslation('errors');
    const apiClient = useAPI();
    const [searchParams] = useSearchParams();
    const [loadingState, setLoadingState] = useState<'loading' | 'loaded' | 'error'>('loading');

    // Check if this is a deep link redirect (expo-web-browser flow)
    const appRedirectUri = searchParams.get('app_redirect_uri');

    useEffect(() => {
        apiClient
            .post('/saml/app-redirect/', {})
            .then((response) => {
                // If app_redirect_uri is provided, redirect to the deep link with the token
                // This is for expo-web-browser flow
                if (appRedirectUri && response.token) {
                    const redirectUrl = `${appRedirectUri}?token=${encodeURIComponent(response.token)}`;
                    window.location.href = redirectUrl;
                    return;
                }

                // Handle wrongApp error for deep link flow
                if (appRedirectUri && response.wrongApp) {
                    const redirectUrl = `${appRedirectUri}?error=wrong_app&wrongApp=true`;
                    window.location.href = redirectUrl;
                    return;
                }

                // Legacy WebView flow: post message to the app
                // The app will run this within a webview and inject this property.
                // The app also does string matching on this message
                (window as any).ReactNativeWebView?.postMessage(
                    'TokenResponse: ' + JSON.stringify(response),
                );
                setLoadingState('loaded');
            })
            .catch((_reason) => {
                // If deep link flow, redirect with error
                if (appRedirectUri) {
                    const redirectUrl = `${appRedirectUri}?error=auth_failed`;
                    window.location.href = redirectUrl;
                    return;
                }
                setLoadingState('error');
            });
    }, []);
    return (
        <Container width={360}>
            <Typography>{t('appRedirect')}</Typography>
            <Box sx={{ pt: 2 }}>
                <LoadingView
                    state={loadingState}
                    errorView={<Typography>{errorT('generic')}</Typography>}
                />
            </Box>
        </Container>
    );
};
